module.exports = __webpack_public_path__ + "static/img/Glucose-Grey-scaled-1.298f1ade.png";